import { render } from "./BandhooNav.vue?vue&type=template&id=5898ead4&scoped=true"
import script from "./BandhooNav.vue?vue&type=script&lang=js"
export * from "./BandhooNav.vue?vue&type=script&lang=js"

import "./BandhooNav.vue?vue&type=style&index=0&id=5898ead4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5898ead4"]])

export default __exports__